import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import routes from 'app/routes';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import StatisticButton from './StatisticButton';
import StatisticModal from './StatisticModal';

export default function SessionsStatistic({ value }) {
  const [showModal, setShowModal] = useState(false);
  const route = routes.api.managers.dashboard.sessions_completed;
  const { state: { filters } } = useContext();
  const { data: programs, loading: programsLoading } = useApiData(showModal && route, filters);

  const columns = [
    {
      name: 'First Name',
      selector: (row) => row.attributes.first_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.attributes.last_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Program',
      selector: (row) => row.attributes.program_title,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Status',
      selector: (row) => `${row.attributes.count_delivered_sessions}/${row.attributes.count_sessions}`,
      sortable: true,
      sortFunction: (a, b) => {
        if (a.attributes.count_sessions === b.attributes.count_sessions) {
          return a.attributes.count_delivered_sessions - b.attributes.count_delivered_sessions;
        }

        return a.attributes.count_sessions - b.attributes.count_sessions;
      },
    },
  ];

  return (
    <Col md="4" className="mb-2 mb-md-0">
      <StatisticButton
        label="Sessions"
        value={value}
        onClick={() => setShowModal(true)}
        className="bg-primary-100"
      />

      <StatisticModal
        show={showModal}
        title="Sessions Completed"
        columns={columns}
        data={programsLoading ? null : programs}
        onCloseClick={() => setShowModal(false)}
      />
    </Col>
  );
}

SessionsStatistic.propTypes = {
  value: PropTypes.number,
};

SessionsStatistic.defaultProps = {
  value: null,
};
